
export default {
    name: "QdapHomeSelectedSection",
    props: {
    
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            pageData: null,
        }
    },



    mounted() {
    },
    methods: {
    },
}
